import {
  RepeatedInfoRequest,
  SimpleCbiEntitiesInfo,
} from '@cbinsights/cbientityservice/cbientityservice';
import { UseQueryResult, useQuery } from 'react-query';
import { getSimpleCbiEntitiesInfo } from '../api/EntitiesEndpoints';
import { MarketForAdminServiceKeys } from './useGetMarketDetails';

export const useSimpleCbiEntitiesInfo = (
  req: RepeatedInfoRequest,
  enabled: boolean
): UseQueryResult<SimpleCbiEntitiesInfo, Error> =>
  useQuery<
    SimpleCbiEntitiesInfo,
    Error,
    SimpleCbiEntitiesInfo,
    [MarketForAdminServiceKeys, RepeatedInfoRequest]
  >({
    queryKey: ['GetSimpleCbiEntitiesInfo', req],
    queryFn: () => getSimpleCbiEntitiesInfo(req),
    notifyOnChangeProps: [
      'data',
      'isFetching',
      'isFetched',
      'isFetchedAfterMount',
    ],
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    retry: false,
    enabled,
  });
